import script from "./ServiceClause.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceClause.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceClause.vue?vue&type=style&index=0&id=69ac68e4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69ac68e4"]])

export default __exports__